export enum TipoVerificacaoEnum {
  Igual = 0,
  ComecaCom = 1,
  Contem = 2,
}

export interface OpcaoTipoVerificacao {
  label: string;
  value: TipoVerificacaoEnum;
}

export const OPCOES_TIPO_VERIFICACAO: OpcaoTipoVerificacao[] = [
  { label: 'Igual a', value: TipoVerificacaoEnum.Igual },
  { label: 'Começa com', value: TipoVerificacaoEnum.ComecaCom },
  { label: 'Contém', value: TipoVerificacaoEnum.Contem },
];
